import React, { useRef, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./GetStartedPopup.css";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearReturnPath } from "../../StateManagement/Reducers/AccountSetupState";

const GetStartedPopup = ({
  title,
  description,
  currentStep,
  totalSteps,
  bullets = [],
  bullets2 = [],
  bullets3 = [],
  bullets4 = [],
  numberedBullets = [],
  bulletheading2,
  bulletheading,
  onBack,
  onNext,
  topClose,
  rightClose,
  onGotIt,
  width,
  onClose,
  thanksnote,
}) => {
  const history = useHistory();
  const popupRef = useRef(null);
  const returnPath = useSelector((state) => state?.returnPath?.path);
  const dispatch = useDispatch();

  // Handle clicks outside the popup
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (popupRef.current && !popupRef.current.contains(event.target)) {
  //       onClose && onClose();
  //       dispatch(clearReturnPath());
  //     }
  //   };

  //   // Add when mounted
  //   document.addEventListener("mousedown", handleClickOutside);

  //   // Clean up when unmounted
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [onClose]);

useEffect(() => {
  const appBody = document.querySelector(".app-body");

  if (appBody) {
    appBody.style.setProperty("overflow", "unset", "important");
    appBody.style.setProperty("position", "unset", "important");
  }

  return () => {
    if (appBody) {
      appBody.style.removeProperty("overflow");
      appBody.style.removeProperty("position");
    }
  };
}, []);

  const handleGotIt = () => {
    onGotIt?.();

    if (returnPath) {
      history.push(returnPath);
      dispatch(clearReturnPath());
      return;
    }
    history.push({
      pathname: `/schedule/calender`,
      state: { getstartedopen: true },
    });
  };

  return (
    <div
      ref={popupRef}
      style={{ width: width }}
      onClick={(e) => e.stopPropagation()} // Prevent clicks inside from bubbling
    >
      <div className="popup-header">
        <h4 className="popup-title">{title}</h4>
        {onClose && (
          <span className="close-button" onClick={onClose}>
            ×
          </span>
        )}
      </div>

      <div className="popup-content">
        {typeof description === "string" ? (
          <p className="popup-description">{description}</p>
        ) : (
          <div className="popup-description">{description}</div>
        )}
        {bulletheading && (
          <p className="popup-bullet-heading">{bulletheading}</p>
        )}
        {bullets.length > 0 && (
          <ul className="popup-bullets">
            {bullets.map((bullet, index) => (
              <li key={index} className="popup-bullet-item">
                {bullet}
              </li>
            ))}
          </ul>
        )}

        {/* Numbered bullets */}
        {numberedBullets.length > 0 && (
          <ol className="popup-numbered-bullets">
            {numberedBullets.map((bullet, index) => (
              <li key={index} className="popup-number-item">
                {bullet}
              </li>
            ))}
          </ol>
        )}

        {bullets4.length > 0 && (
          <ol className="popup-bullets">
            {bullets4.map((bullet, index) => (
              <li key={index} className="popup-bullet-item">
                {bullet}
              </li>
            ))}
          </ol>
        )}

        {bulletheading2 && (
          <p className="popup-bullet-heading">{bulletheading2}</p>
        )}
        {bullets2.length > 0 && (
          <ul className="popup-bullets">
            {bullets2.map((bullet, index) => (
              <li key={index} className="popup-bullet-item">
                {bullet}
              </li>
            ))}
          </ul>
        )}
        {bullets3.length > 0 && (
          <ol className="popup-orderbullets">
            {bullets3.map((bullet, index) => (
              <li key={index} className="popup-orderbullet-item">
                {bullet}
              </li>
            ))}
          </ol>
        )}
        {thanksnote && <p>{thanksnote}</p>}
      </div>

      <div className="popup-footer">
        <div className="step-counter">
          {currentStep}/{totalSteps}
        </div>

        <div className="button-group">
          {onBack && (
            <Button
              className="popup-button back-button"
              variant="outline-primary"
              onClick={onBack}
            >
              Back
            </Button>
          )}
          {onNext ? (
            <Button
              className="popup-button next-button"
              variant="primary"
              onClick={onNext}
            >
              Next
            </Button>
          ) : (
            <Button
              className="popup-button next-button"
              variant="primary"
              onClick={handleGotIt}
            >
              Got It
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetStartedPopup;
